import { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components'
import queryString from 'query-string'
import ReCAPTCHA from "react-google-recaptcha";

import { getOrderTracking } from '../request/Request';
import { useForm } from '../hooks/UseForm';

import { DispatchItem } from './DispatchItem';
import { Graphic } from './Graphic';
import { WarningBlock } from './WarningBlock';
import { Loader } from './Loader';

import { sitekey } from '../config';
import { ModalHelp } from './ModalHelp';

const WrapperStyle = styled.div`
max-width: 826px;
width: 90%;
margin: 4rem auto;
h1 {
    font-size: 24px;
    text-align: center;
    font-weight: 500;
    line-height: 38px;
}
h3 {
    font-size: 20px;
    margin: 30px 10px 15px;
    font-weight: normal;
}
.service_client {
  text-align: center;
  font-size: 14px;
}
@media (min-width: 764px) {
    h1 {
        font-size: 32px;
        font-weight: 500;
        line-height: 38px;
    }
}
`;

const SearchBox = styled.div`
background: #F5F5F5;
border-radius: 6px;
padding: 16px 16px 24px;
line-height:27px;
text-align: center;
margin-bottom: 1rem;

h4{
    margin-bottom: 10px;
    font-weight: 500;
    font-size: 16px;
    line-height: 18px;
}
p{
    text-align: left;
}
.description-box {
    display: flex;
    gap: 10px;
    max-width: 676px;
    margin: 0 auto;
    font-size: 15px;
}
.input-box {
    max-width: 550px;
    text-align: left;
    margin: 0 auto;
}
input{
    border: 1px solid #979797 !important;
    box-sizing: border-box;
    border-radius: 6px;
    color: #2E353F;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
    margin-bottom: 14px;
    padding: 8px 10px;
    width: 100%;
    font-family: "Avant Garde", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
input::placeholder {
    color: #B9B9B9;
    font-weight: 400;
    font-size: 16px;
    line-height: 18px;
    margin: 0px 10px;
  }
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
button {
    background: #E0004D;
    border-radius: 6px;
    border: none;
    color: #FFFFFF;
    cursor: pointer;
    font-weight: 700;
    font-size: 18px;
    height: 50px;
    width: 100%;
}
@media (min-width: 764px) {
    input {
        max-width: 370px;
    }
    button {
        max-width: 150px;
        margin:1px 15px;
    }
}
`;

export const SearchView = () => {

    const [orderTracking, setOrderTracking] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [token, setToken] = useState(null);
    const [order, setOrder] = useState('');

    const reCaptchaRef = useRef();

    const navigate = useNavigate();
    const location = useLocation();

    const { q = ''} = queryString.parse(location.search);
 
    const [ formValues, handleInputChange ] = useForm({
        OrderID: q ? q : order,
    });

  
    const { OrderID } = formValues;

    useEffect(() =>  {
        if(order){

            setOrderTracking(null)
            setLoading(true)

            getOrderTracking({order , token})
            .then( ({data}) => setOrderTracking(data))
            .catch((err) => setError(err))
            .finally(() => {setLoading(false); reCaptchaRef.current.reset()}) 

        }
            
    }, [token]);

    const handleChange = value => {
        value && setToken(value)
        
      };

    const handleSearch = e => {
        e.preventDefault();
        reCaptchaRef.current.execute();
        
        setOrder(OrderID)
        //  navigate(`?q=${ OrderID }`)
    }

    return (
        <WrapperStyle>
            <h1>Seguimiento de tu compra</h1>

                <Graphic />

                <SearchBox>
                    <div className='description-box'>
                       <p><strong>El número de seguimiento de tu compra es el mismo que el de tu boleta o factura. </strong>La cual recibiste por mail o tras tu compra en una de nuestras tiendas Abcdin.</p>
                        <ModalHelp />
                    </div>
                    
                    <form onSubmit={ handleSearch }>
                        <div className='input-box'>
                            <h4>Número de boleta o factura</h4>
                            <input 
                                type="number"
                                placeholder="Ejemplo: 1068438791"
                                name="OrderID"
                                id="OrderID"
                                autoComplete="off"
                                value={ OrderID }
                                onChange={ handleInputChange }
                                required
                            />  

                            <button 
                                type="submit">
                                Buscar &#8250;
                            </button>
                            <ReCAPTCHA
                                sitekey={sitekey}
                                size="invisible"
                                ref={reCaptchaRef}
                                onChange={handleChange}
                                />
                        </div>
                    </form>
                </SearchBox>

                { loading
                    ? 
                       <Loader />
                    : (
                        <div>
                            { orderTracking
                                    ? (
                                        <div>
                                            <h3>Pedido N° <strong>{order}</strong></h3> 
                                                {orderTracking.dispatch.map(order => (
                                                        <DispatchItem
                                                            key={ order.id }
                                                            order={ order }
                                                        />
                                                    ))
                                                }
                                        </div>
                                        ) 
                                    : (order !== '') && <WarningBlock />
                            }
                        </div>
                    )
                }
               
                <p className="service_client">Si no tienes acceso al <strong>número de tu boleta</strong>, por favor llama a nuestro <strong>Servicio al Cliente al <a style={{color: '#000'}} href="tel:6008302222"><span style={{textDecoration: 'underline'}}>600 830 2222</span></a></strong></p>

        </WrapperStyle>
    )
}